import * as client from "../../../client";

export type AttachmentMapping = client.Attachment["original_mapping"];

// An attachment's effective classification: a manual re-mapping wins over the
// original. Mirrors Attachment.mapping() on the backend and the COALESCE in
// LIST_REPORTS_METADATA_QUERY; keep the three in sync.
export const effectiveMapping = (a: client.Attachment): AttachmentMapping =>
  a.manual_mapping ?? a.original_mapping;

// Parses an attachment's uploaded_at timestamp. Returns null for missing or
// unparseable values — note new Date("garbage") doesn't throw, it returns an
// Invalid Date, so callers can't rely on try/catch.
export const parseUploadedAt = (
  uploadedAt: string | null | undefined
): Date | null => {
  if (!uploadedAt) {
    return null;
  }
  const date = new Date(uploadedAt);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const attachmentsUiTypeMap: { [type in AttachmentMapping]: string } = {
  acord_app: "Acord App",
  loss_run: "Loss Run",
  sov_spreadsheet: "Sov Spreadsheet",
  screenshot: "Image",
  rater: "Rater",
  none: "None",
  loss_control_report: "Loss Control Report",
  policy_document: "Policy Document",
  manuscript_form: "Manuscript Form",
  final_manuscript_form: "Final Manuscript Form",
  specs_sheet: "Specs Sheet",
  record_keeping: "Record Keeping",
  luminor_quote: "Luminor Quote",
  luminor_tria: "Luminor TRIA",
  luminor_binder: "Luminor Binder",
  luminor_policy: "Luminor Policy",
  lead_quote: "Lead Quote",
  lead_binder: "Lead Binder",
  lead_policy: "Lead Policy",
  bound_sov: "Bound SOV",
  sl_letter: "SL Letter",
  endorsement_file: "Endorsement File",
  endorsement_sov: "Endorsement SOV",
  engineering_report: "Engineering Report",
  rate_matrix: "Rate Matrix",
  form_review: "Form Review",
};
